import { useContext, useEffect, useState } from "react";
import { Menu, MenuHandler, MenuList } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import * as publicApi from "../../service/publicApi";
import * as notifyApi from "../../service/notifyApi";
import ModalSwitchRole from "../material/modal/ModalSwitchRole";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { CurrentUserContext } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

import TopMenu from "./topMenu";
import MenuGuest from "./menuRole/menuGuest";
import Bell from "./menuRole/bell";
import MenuInfoPatient from "./menuRole/menuInfoPatient";
import MenuInfoDoctor from "./menuRole/menuInfoMedical";
import MenuInfoAdminLab from "./menuRole/menuInfoAdminLaboratory";
import MenuInfoLab from "./menuRole/menuInfoPersonalLaboratory";
import MenuInfoHospitalPersonnel from "./menuRole/menuInfoHospitalPersonal";
import MenuInfoExecutive from "./menuRole/menuInfoExecutive";
import MenuInfoHospital from "./menuRole/menuInfoHospital";
import MenuInfoAdmin from "./menuRole/menuInfoAdmin";
import MobileMenuList from "./menuMobile/menuMobile";

const MenuLegged = () => {
  const { setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notifyList, setNotifyList] = useState([]);
  const [page, setPage] = useState(1);
  const [contentHover, setContentHover] = useState(false);
  // const [getNotificationTotal, setGetNotificationTotal] = useState(
  //   localStorage.getItem("Notification"),
  // );
  const [menuActive, setMenuActive] = useState();
  const [navMenu, setNavMenu] = useState([]);

  // const [checkUserAfterLogin, setCheckUserAfterLogin] = useState(
  //   localStorage.getItem("user"),
  // );
  const checkUserAfterLogin = localStorage.getItem("user");
  const location = useLocation();

  const [subMenuHover, setSubMenuHover] = useState({ name: "", status: false });
  const [childMenuHover, setChildMenuHover] = useState({
    name: "",
    status: false,
  });

  const [new_notify, setNew_nottify] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const [open, setOpen] = useState(false);
  const roleList = ["MEDICAL_PERSONNEL", "PATIENT"];
  const user = JSON.parse(localStorage.getItem("user"));
  const openNotification = user?.["auth"]["role"][0]
    ? roleList.includes(user?.["auth"]["role"][0])
    : null;
  useEffect(() => {
    if (localStorage.getItem("Notification") === null) {
      // setGetNotificationTotal(0);
    }
    if (user) {
      getRequestPermission();
      setUserRole(user);
    }
  }, [checkUserAfterLogin]);

  const [width, setWidth] = useState(0);

  useEffect(() => {
    getMenu();
  }, [user?.["auth"]["role"][0]]);

  useEffect(() => {
    if (location.state) {
      setMenuActive(location.state);
    } else {
      setMenuActive(location.pathname);
    }
  }, [navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (width > 767) {
      setOpen(false);
    }
  }, [width]);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await notifyApi.getNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setNotifyList(res["data"]["notification_list"]);
        localStorage.setItem(
          "Notification",
          res["data"]["notification_list"].length,
        );
        setNew_nottify(res["data"]["is_new_badge"]);
      } else if (res["data"]["code"] === 401) {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        navigate("/login");
        return;
      } else {
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const setReadNotification = async () => {
    setLoading(true);
    let res = await notifyApi.setReadNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        getRequestPermission();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getMenu = async () => {
    let res = await publicApi.getMenuNav(
      user?.["auth"]["role"][0] ? user?.["auth"]["role"][0] : "PUBLIC",
    );
    if (res) {
      if (res["data"]["code"] === 200) {
        setNavMenu(res["data"]["menu_list"]);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div>
      <div className="lg:hidden">
        <TopMenu menuActive={menuActive} />
      </div>

      {/* desktop */}
      <div className="z-10 lg:hidden lg:top-[30px] fixed top-[34px] left-0 right-0 flex justify-between items-center bg-white lg:pl-[50px] shadow-md w-full">
        <div className="flex h-[80px] p-4 items-center gap-[30px] xl:gap-[15px]">
          <img
            className="h-full object-cover cursor-pointer"
            src={require("../../asset/image/logo.svg").default}
            onClick={() => navigate("/")}
            alt="รูปภาพสัญลักษณ์เว็บไซต์"
          ></img>

          {navMenu.map((item, index) => (
            <div
              key={index}
              className={`lg:text-sm flex text-black text-base items-center h-[80px] cursor-pointer ${
                menuActive === item.link
                  ? "border-b-[3px] border-b-[#43A1EF]"
                  : "border-b-0"
              }`}
              onMouseEnter={() =>
                item.submenu.length !== 0
                  ? setSubMenuHover({ name: item.name, status: true })
                  : ""
              }
              onMouseLeave={() =>
                item.submenu.length !== 0
                  ? setSubMenuHover({ name: item.name, status: false })
                  : ""
              }
            >
              <div
                className="text-base w-full font-bold text-center"
                onClick={() =>
                  item.link === "-"
                    ? {}
                    : navigate(item.link, { state: item.link })
                }
              >
                {item.name}
              </div>

              {item.submenu.length !== 0 &&
                subMenuHover.name === item.name &&
                subMenuHover.status && (
                  <div className="absolute top-20 w-70 bg-white rounded-bl-md shadow-lg">
                    {item.submenu.map((data, subIndex) => (
                      <div
                        key={subIndex}
                        className="relative flex w-full px-5 py-2 border-b border-gray-400"
                        onMouseEnter={() =>
                          data.submenu.length !== 0
                            ? setContentHover({
                                name: data.name,
                                status: true,
                              })
                            : ""
                        }
                        onMouseLeave={() =>
                          data.submenu.length !== 0
                            ? setContentHover({
                                name: data.name,
                                status: false,
                              })
                            : ""
                        }
                      >
                        <div
                          className="w-full"
                          onClick={() =>
                            navigate(data.link, { state: item.link })
                          }
                        >
                          {data.name}
                        </div>
                        {data.submenu.length !== 0 && (
                          <div className="flex justify-end items-center ">
                            <FontAwesomeIcon
                              icon={faAngleRight}
                            ></FontAwesomeIcon>
                          </div>
                        )}

                        {data.submenu.length !== 0 && contentHover.status && (
                          <>
                            <div className="xl:-left-[285px] absolute top-0 left-64 w-auto text-nowrap bg-gray-200 rounded-br-md shadow-lg">
                              {data.submenu.map((child) => (
                                <div
                                  className="flex px-5 py-2 border-b border-gray-400"
                                  // onClick={() => navigate(child.link)}
                                  onClick={() =>
                                    navigate(child.link, { state: item.link })
                                  }
                                >
                                  {child.name}
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}
            </div>
          ))}
        </div>

        {user?.["auth"]["role"][0] ? (
          <div className="flex justify-end items-center text-3xl top-7 right-0 p-0">
            {user?.["auth"]["role"][0] === "PATIENT" ||
            user?.["auth"]["role"][0] === "MEDICAL_PERSONNEL" ? (
              <>
                <Bell
                  new_notify={new_notify}
                  setReadNotification={setReadNotification}
                  menuActive={menuActive}
                />
              </>
            ) : null}
            <div>
              {user?.["auth"]["role"][0] === "ADMIN" ? (
                <MenuInfoAdmin setOpen={setOpen} setOpenModal={setOpenModal} />
              ) : user?.["auth"]["role"][0] === "MEDICAL_PERSONNEL" ? (
                <MenuInfoDoctor setOpen={setOpen} setOpenModal={setOpenModal} />
              ) : user?.["auth"]["role"][0] === "LABORATORY_PERSONNEL" ? (
                <MenuInfoLab setOpen={setOpen} setOpenModal={setOpenModal} />
              ) : user?.["auth"]["role"][0] === "LABORATORY_ADMIN" ? (
                <MenuInfoAdminLab
                  setOpen={setOpen}
                  setOpenModal={setOpenModal}
                />
              ) : user?.["auth"]["role"][0] === "HOSPITAL" ? (
                <MenuInfoHospital
                  setOpen={setOpen}
                  setOpenModal={setOpenModal}
                />
              ) : user?.["auth"]["role"][0] === "HOSPITAL_PERSONNEL" ? (
                <MenuInfoHospitalPersonnel
                  setOpen={setOpen}
                  setOpenModal={setOpenModal}
                />
              ) : user?.["auth"]["role"][0] === "EXECUTIVE" ? (
                <MenuInfoExecutive
                  setOpen={setOpen}
                  setOpenModal={setOpenModal}
                />
              ) : user?.["auth"]["role"][0] === "PATIENT" ? (
                <MenuInfoPatient
                  setOpen={setOpen}
                  setOpenModal={setOpenModal}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <MenuGuest menuActive={menuActive} />
        )}
      </div>

      {/* mobile */}
      <div className="lg:flex shadow-lg hidden z-10 fixed justify-between items-center gap-10 w-full text-3xl cursor-pointer top-0 right-0 px-5 py-2 bg-white">
        <div className="w-[100px]">
          <img
            className="object-cover cursor-pointer w-full"
            src={require("../../asset/image/logo.svg").default}
            onClick={() => navigate("/")}
            alt="รูปภาพสัญลักษณ์เว็บไซต์ ขนาดจอโทรศัพท์"
          ></img>
        </div>

        <div className="flex flex-row items-center">
          {openNotification ? (
            <div
              onClick={() => {
                if (new_notify) {
                  setReadNotification();
                }
              }}
            >
              <div>
                <button
                  onClick={() => {
                    navigate("/notification");
                  }}
                  className="flex h-full outline-none items-center mr-5 relative"
                >
                  <FontAwesomeIcon
                    icon={faBell}
                    alt="notify"
                    className={`w-[16px] h-[18px] p-1 rounded-full lg:w-[20px] lg:h-[20px] ${
                      menuActive === "/notification"
                        ? "text-blue-500 bg-[#cae1ff8c]"
                        : "text-black"
                    }`}
                  />
                  {new_notify ? (
                    <>
                      <div
                        className={`absolute flex items-center justify-center -top-2 -right-2 w-4 h-4 text-[0.65rem] text-[#FFFFFF] font-medium leading-tight border-[#FFFFFF] border-2 bg-[#ff4545] rounded-full cursor-pointer hover:scale-110 transition-all duration-300`}
                      ></div>
                    </>
                  ) : null}
                </button>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="flex items-center">
            <Menu
              open={open}
              handler={setOpen}
              placement="bottom-end"
              dismiss={{
                itemPress: false,
                outsidePress: true,
              }}
            >
              <MenuHandler>
                <button className="outline-none p-2 active:bg-gray-100 rounded-lg transition-colors">
                  {open ? (
                    <XMarkIcon className="w-6 h-6 text-[#26A0A4] stroke-[2.5px]" />
                  ) : (
                    <Bars3Icon className="w-6 h-6 text-[#26A0A4] stroke-[2.5px]" />
                  )}
                </button>
              </MenuHandler>

              <MenuList className="flex flex-col p-0 border-none shadow-2xl rounded-xl !z-[9999] !min-w-[280px] mt-4">
                <MobileMenuList
                  user={user}
                  navMenu={navMenu}
                  menuActive={menuActive}
                  navigate={navigate}
                  setOpen={setOpen}
                  setOpenModal={setOpenModal}
                  subMenuHover={subMenuHover}
                  setSubMenuHover={setSubMenuHover}
                  childMenuHover={childMenuHover}
                  setChildMenuHover={setChildMenuHover}
                />
              </MenuList>
            </Menu>
          </div>
        </div>
      </div>

      {openModal && <ModalSwitchRole onClose={() => setOpenModal(false)} />}
    </div>
  );
};
export default MenuLegged;
